import { useEffect, useState } from "react";
import { api, unwrapArray } from "@/lib/api";
import { unwrapPage } from "@/lib/paging";
import type { AgentRecord } from "@/types";

/** Active agents for pickers; stays empty for users who may not view agents */
export function useAgents(): AgentRecord[] {
  const [agents, setAgents] = useState<AgentRecord[]>([]);
  useEffect(() => {
    api
      .get("/api/Agent/List?active=true&page_size=100")
      .then((res) => setAgents(unwrapPage<AgentRecord>(res).rows))
      .catch(() => undefined);
  }, []);
  return agents;
}
